import EventEmitter from 'eventemitter3';

// https://nodejs.org/api/events.html
class Events extends EventEmitter {
  // Log emitted events (if not blacklisted)
  emit(...args) {
    const [name, ...params] = args;

    if (this.logBlacklist && this.logBlacklist.indexOf(name) === -1) {
      console.info(name, params);
    }

    super.emit(...args);
  }
}

const instance = new Events();

instance.logBlacklist = [];

// Fire at window resize -> [width, height, ratio]
// instance.RESIZE = 'resize';
// Fire at virtual scroll -> [{x, y, deltaX, deltaY, originalEvent}]
// instance.SCROLL = 'scroll';
// instance.logBlacklist.push(instance.SCROLL);

// Fire when nav is sticky
instance.STICK = 'stick';
// Fire when nav is no more sticky
instance.UNSTICK = 'unstick';

export default instance;
